import { Dialog } from '@angular/cdk/dialog';
import { CdkOverlayOrigin, Overlay, OverlayModule } from '@angular/cdk/overlay';
import { ChangeDetectionStrategy, Component, TemplateRef, inject, input, viewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

import type { UserSession } from '@asset-solutions/customer-portal/auth/data-access';

@Component({
  selector: 'cp-account-manager',
  imports: [OverlayModule, MatIcon, MatTooltip],
  templateUrl: './account-manager.component.html',
  styleUrl: './account-manager.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountManagerComponent {
  public readonly template = viewChild<TemplateRef<any>>('dialogTemplate');
  public readonly origin = viewChild(CdkOverlayOrigin);
  public readonly userSession = input<UserSession>();
  private readonly dialog = inject(Dialog);
  private readonly overlay = inject(Overlay);

  protected openOverlay(): void {
    const template = this.template();
    const origin = this.origin();

    if (template && origin) {
      this.dialog.open(template, {
        positionStrategy: this.overlay
          .position()
          .flexibleConnectedTo(origin.elementRef)
          .withPositions([
            { originX: 'center', originY: 'bottom', overlayX: 'center', overlayY: 'top' },
            { originX: 'end', originY: 'bottom', overlayX: 'end', overlayY: 'bottom' }
          ])
          .withPush(true),
        backdropClass: 'cdk-overlay-transparent-backdrop'
      });
    }
  }
}
